<template>
    <div class="md-wrapper">
        <vue-markdown class="markdown"
                      :prerender="mdService.prerender"
                      :postrender="mdService.postrender"
                      @rendered="mdService.rendered(element || '#markdown')"
                      :source="source"/>
    </div>
</template>

<script>
	import VueMarkdown from 'vue-markdown';
	import MarkdownService from "@/services/MarkdownService";

	export default {
		components: {VueMarkdown},
		name: "MarkdownWrapper",
		props: {
			source: {
				type: String,
				required: true
			},
			element: {
				type: String,
				required: false
			}
		},
		data() {
			return {
				mdService: MarkdownService
			}
		}
	}
</script>

<style scoped>
    .markdown {
        display: contents;
    }
</style>